import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📚 CÓDIGO INFIDELIDAD (12 Tomos)',
  price: '$19'
}, {
  label: '🎁 Protocolo Cero Errores',
  price: 'GRATIS'
}, {
  label: '🎁 Guion Anti-Humillación',
  price: 'GRATIS'
}, {
  label: '🎁 Radar de Desencadenantes',
  price: 'GRATIS'
}, {
  label: '🎁 Apagá el Infierno Mental',
  price: 'GRATIS'
}, {
  label: '🎁 Decisión en Frío',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Débito / Crédito'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="border-y border-white/5 bg-ink-2" data-id="element-190" data-mp="30xlfdf01krt8">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" data-id="element-191" data-mp="35r7v5g1i5bt9">
        <h2 className="font-display text-2xl font-black text-white sm:text-4xl" data-id="element-192" data-mp="1tg4tkcdhxho1">
          🚀 Empezá el Día 1 desde hoy
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-white/60" data-id="element-193" data-mp="1oe7430ei5qmn">
          Por menos de lo que cuesta una consulta psicológica tenés acceso de por vida. Todo el
          sistema listo para aplicar en minutos.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-194" data-mp="2c5ku2zp6la4g">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50" data-id="element-195" data-mp="284j479h5maf5">
            <span data-id="element-196" data-mp="2m3ikntuijj08">Qué incluye</span>
            <span data-id="element-197" data-mp="2h4xqoc5utvk8">Precio</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-white/5 px-5 py-3.5 text-sm" data-id="element-198" data-mp="2h2us33qmyu3w">
              <span className="text-white/80" data-id="element-199" data-mp="ms7xjwnb8qdw">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-white' : 'shrink-0 font-bold text-plata'} data-id="element-200" data-mp="2mtflylvlso0v">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-wrap items-center justify-between gap-2 bg-vino/40 px-5 py-4" data-id="element-201" data-mp="30tgmu1bvbvgc">
            <span className="text-sm font-bold text-white" data-id="element-202" data-mp="35sjt1p3l47pw">
              Valor total real: <span className="text-white/40 line-through" data-id="element-203" data-mp="3ar4svnexcpdt">$80</span>
            </span>
            <span className="text-plata-shine font-display text-2xl font-black" data-id="element-204" data-mp="3aos3ip6u7cqq">$19</span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-205" data-mp="3jj6ptbpsbnjc">
          <CTAButton data-id="element-206" data-mp="3jix1rtoavqga">Quiero el protocolo ahora</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-207" data-mp="3ojkow49ern58">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-208" data-mp="7fvjjpefkfeo">
              <Icon className="h-4 w-4 text-plata" data-id="element-209" data-mp="7dsous2c1y3m" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}